import type { RunListQuery } from '@console/types'
import { useQuery } from '@tanstack/react-query'
import { fetchExternalHealth, fetchRun, fetchRuns } from './api.js'

export function useRuns(query: RunListQuery) {
  return useQuery({
    queryKey: ['runs', query],
    queryFn: () => fetchRuns(query),
  })
}

export function useRun(id: string) {
  return useQuery({
    queryKey: ['run', id],
    queryFn: () => fetchRun(id),
  })
}

/**
 * 5-minute `staleTime`, matching the aggregate cache tier the backend's
 * `CadenceClient` itself uses (tech stack §2) — no point polling the
 * frontend's copy faster than the number behind it can actually change.
 *
 * `enabled` defaults to `true` but should be passed as `false` until the
 * caller is actually authenticated — the endpoint requires a session, and
 * `useQuery` fires on mount regardless of surrounding component state (hooks
 * can't be called conditionally), so an unauthenticated visitor would
 * otherwise generate a guaranteed 401 on every page load before login.
 */
export function useExternalHealth(enabled = true) {
  return useQuery({
    queryKey: ['external-health'],
    queryFn: fetchExternalHealth,
    staleTime: 5 * 60_000,
    enabled,
  })
}
